import { render } from "./openclose.vue?vue&type=template&id=793322f4"
import script from "./openclose.vue?vue&type=script&lang=js"
export * from "./openclose.vue?vue&type=script&lang=js"

import "./openclose.vue?vue&type=style&index=0&id=793322f4&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__